import React, { FC } from 'react';
import classNames from 'classnames';

import { Icon, IconSize } from 'app/design-system/components/Icon';
import { Spinner } from 'app/design-system/components/Spinner';

import { MatchRowStatus } from '../../constants';

import styles from './ExpansionButton.module.scss';

// ---

type ExpansionButtonProps = {
  dataGaValues?: Record<string, string>;
  expansionState: MatchRowStatus;
  onClick?: VoidFunction;
  className?: string;
  iconSize?: IconSize;
};

const ExpansionButton: FC<ExpansionButtonProps> = ({
  dataGaValues,
  expansionState,
  onClick,
  className,
  iconSize = 10,
}) => {
  return (
    <button {...dataGaValues}
            data-test="expansion-button"
            type="button"
            className={classNames(styles.expansionButton, className)}
            onClick={onClick}>
      {expansionState === MatchRowStatus.LOADING ? (
        <Spinner size={20} />
      ) : (
        <Icon
          icon="chevron-down-thin"
          size={iconSize}
          className={classNames(
            styles.expansionIcon,
            { [styles.rotated]: expansionState === MatchRowStatus.EXPANDED },
          )} />
      )}
    </button>
  );
};

export default ExpansionButton;
